<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef" :select-list.sync="selectList">
      <template slot="searchBar">
        <el-form-item label="导入时间">
          <date-range-picker :start.sync="tableData.search.start_at" :end.sync="tableData.search.end_at" type="before" width="250px"/>
        </el-form-item>
        <el-form-item label="SN">
          <el-input v-model.trim="tableData.search.sn" clearable/>
        </el-form-item>
        <el-form-item label="设备名">
          <el-input v-model.trim="tableData.search.name" clearable/>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model.trim="tableData.search.model" clearable/>
        </el-form-item>
        <el-form-item label="自定义型号">
          <el-input v-model.trim="tableData.search.model_x" clearable/>
        </el-form-item>
        <el-form-item label="硬件平台">
          <el-select v-model="tableData.search.plat" filterable clearable>
            <el-option v-for="(item, index) in platformType" :key="index" :label="item" :value="item"/>
          </el-select>
        </el-form-item>
        <el-form-item label="批次">
          <el-input v-model.trim="tableData.search.batch_no" clearable/>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button-group>
          <el-button v-if="checkApi('reviseDevice')" size="small" type="primary" @click="showCustomBatch" :disabled="!selectList.length">批量自定义</el-button>
          <el-button v-if="checkApi('deleteDevice')" size="small" type="primary" @click="showRemoveBatch">删除批次</el-button>
          <el-button v-if="checkApi('importDevice')" size="small" type="primary" @click="add">导入设备</el-button>
        </el-button-group>
      </template>
      <template v-if="hasApi(['reviseDevice','deleteDevice'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="160">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('reviseDevice')" type="text" @click="revise(row)">自定义</el-button>
            <el-button v-if="checkApi('deleteDevice')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <import-device v-if="importDevice.visible" :dialog-data="importDevice" @table-reload="getTableList"/>
    <custom-device v-if="customDevice.visible" :dialog-data="customDevice" @table-reload="getTableList"/>
    <delete-batch-no v-if="deleteBatchNo.visible" :dialog-data="deleteBatchNo" @table-reload="getTableList"/>
    <custom-device-batch v-if="customDeviceBatch.visible" :dialog-data="customDeviceBatch" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import ImportDevice from "./dialog/ImportDevice"
  import CustomDevice from "./dialog/CustomDevice"
  import DeleteBatchNo from "./dialog/DeleteBatchNo"
  import CustomDeviceBatch from "./dialog/CustomDeviceBatch"
  import DateRangePicker from "@view/components/date/DateRangePicker"
  import {platformType} from "@utils/formatList"
  export default {
    name: "deviceManage",
    components: {ImportDevice, CustomDevice, DateRangePicker, DeleteBatchNo, CustomDeviceBatch},
    data() {
      return {
        platformType,
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "ID", property: "id"},
            {label: "批次", property: "batch_no", width: 170},
            {label: "SN", property: "sn", width: 200},
            {label: "设备名", property: "name"},
            {label: "自定义名称", property: "name_x"},
            {label: "设备型号", property: "model"},
            {label: "自定义型号", property: "model_x"},
            {label: "硬件平台", property: "plat"},
            {label: "导入时间", property: "create_at"},
            {label: "备注", property: "remark"},
          ],
          api: "getDeviceCustom",
          search: {
            start_at: "",
            end_at: "",
            sn: "",
            name: "",
            model: "",
            model_x: "",
            plat: "",
            batch_no: "",
          },
          isMultiple: true,
        },
        countList: [{name: "总记录", count: 0}],
        selectList: [],
        importDevice: {visible: false, width: 500, title: "导入设备"},
        customDevice: {visible: false, width: 500, title: "自定义设备", row: null},
        deleteBatchNo: {visible: false, width: 400, title: "删除批次"},
        customDeviceBatch: {visible: false, width: 500, title: "批量自定义设备"},
      }
    },
    methods: {
      add() {
        this.importDevice.visible = true;
      },
      revise(row) {
        this.customDevice.visible = true;
        this.customDevice.row = row;
      },
      remove(row) {
        this.openConfirm(`删除授权 ${row.sn}`, async () => {
          let nv = {
            type: "one",
            device_custom_id: row.id
          };
          let res = await this.$Http.deleteDevice(nv);
          if (res) {
            this.msgSuccess("操作成功");
            this.getTableList();
          }
        });
      },
      showCustomBatch() {
        this.customDeviceBatch.visible = true;
        this.customDeviceBatch.list = this.selectList;
      },
      showRemoveBatch() {
        this.deleteBatchNo.visible = true;
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
